import { FC, useState, ChangeEvent } from 'react';
import { v4 as uuid } from 'uuid';
// Redux
import { useAppDispatch } from 'hooks/useStore';
// Component
import { Button } from 'components/Buttons';
import { Input } from 'components/Controls';
// Selectors
import { setQuestionStart } from 'store/player/playerSlice';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  onSubmit: (answer:{ ref:string, title:string, correct?:boolean }) => void;
  disabled?: boolean;
};

const TextAnswer:FC<Props> = ({ onSubmit, disabled = false }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [ clicked, setClicked ] = useState<boolean>(false);
  const [ title, setTitle ] = useState<string>('');

  const handleTitle = (e: ChangeEvent<HTMLInputElement>) => {
    setTitle(e.target.value);
  }

  const handleSubmit = () => {
    if(clicked) return;
    onSubmit({
      ref: uuid(),
      title,
    });
    dispatch(setQuestionStart(false));
    setClicked(true);
  }

  return (
    <div>
      <Input
        name="question-free-answer" id="question-free-answer" placeholder={t('labels.freeText')}
        value={title}
        onChange={handleTitle}
        disabled={disabled || clicked}
      />
      <Button
        className="w-full text-xl uppercase primary-button"
        onClick={handleSubmit}
        disabled={!title.trim() || clicked}
      >
        {t('buttons.next')}
      </Button>
    </div>
  )
}

export default TextAnswer;
